/* Eigen cartlade (22-10-2026), vervangt UpCart. Zelfde bestand in elke winkel.
 *
 * De inhoud van de lade rendert Shopify zelf (sections/cart-lade.liquid). Dit script doet
 * alleen het openen en sluiten, het aantal aanpassen, de timer laten lopen en de lade
 * verversen via de Section Rendering API. Zo staat er geen prijs- of kortingslogica in
 * JavaScript die uit de pas kan lopen met Shopify.
 *
 * Openen gebeurt op drie manieren:
 *   1. het thema voegt toe (theme.js vuurt `ajaxProduct:added`, ook de sticky knop);
 *   2. elke andere geslaagde fetch naar /cart/add (apps, snelle weergave);
 *   3. een klik op het winkelwagenicoon of een link naar /cart, en het event `cart:open`.
 * Op de winkelwagenpagina zelf blijft alles zoals het was.
 *
 * Lasso (Emma): staat het Lasso-script in de pagina, dan gaat de checkoutknop altijd via
 * `window.proceedToCheckout`. Lasso bouwt `button[name=checkout]` zelf om (ook na elke
 * nieuwe render, via zijn MutationObserver), maar pas na twee API-aanroepen na elke
 * paginalading. In dat gat ging een klik vroeger naar de Shopify-checkout
 * (upcart-checkoutlink-omzeilt-lasso). Hier wacht de knop dan tot Lasso er is; na 10 s
 * zonder Lasso gaat hij alsnog naar de Shopify-checkout, zodat de verkoop niet verloren gaat.
 */
(function () {
  "use strict";

  if (window.__CART_LADE__) return;
  window.__CART_LADE__ = "2026-10-22.1";

  var SECTION = "cart-lade";
  var K_TIMER = "cart_lade_timer_end";
  var onCartPage = document.body.classList.contains("template-cart");
  var timerTick = null;
  var refreshTimer = null;

  function root() { return document.getElementById("CartLade"); }
  function enabled() { var r = root(); return !!r && !r.classList.contains("cart-lade--off"); }

  // ── Openen en sluiten ────────────────────────────────────────────────────
  function open() {
    var r = root();
    if (!r || !enabled()) return;
    r.classList.add("is-open");
    r.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("cart-lade-lock");
    startTimer();
    var c = r.querySelector(".cart-lade__close");
    if (c) setTimeout(function () { try { c.focus({ preventScroll: true }); } catch (e) {} }, 50);
  }

  function close() {
    var r = root();
    if (!r) return;
    r.classList.remove("is-open");
    r.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("cart-lade-lock");
  }

  // ── Verversen ────────────────────────────────────────────────────────────
  function apply(html) {
    var r = root();
    if (!r || !html) return;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var fresh = doc.querySelector("[data-cart-lade]");
    if (!fresh) return;
    var oldInner = r.querySelector("[data-cart-lade-inner]");
    var newInner = fresh.querySelector("[data-cart-lade-inner]");
    if (oldInner && newInner) oldInner.replaceWith(newInner);
    r.setAttribute("data-count", fresh.getAttribute("data-count") || "0");
    updateBubble();
    startTimer();
  }

  function refresh() {
    var url = location.pathname + "?sections=" + SECTION + "&t=" + Date.now();
    return fetch(url, { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { if (data) apply(data[SECTION]); })
      .catch(function () {});
  }

  // Na een toevoeging komen het event van het thema en de fetch-haak allebei langs;
  // één verversing is genoeg.
  function refreshAndOpen() {
    if (onCartPage || !enabled()) return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { refresh().then(open); }, 30);
  }

  function updateBubble() {
    var r = root();
    var n = r ? parseInt(r.getAttribute("data-count") || "0", 10) : 0;
    document.querySelectorAll(".cart-link__bubble").forEach(function (b) {
      b.classList.toggle("cart-link__bubble--visible", n > 0);
    });
  }

  // ── Aantal aanpassen ─────────────────────────────────────────────────────
  function change(item, qty) {
    if (!item) return;
    item.classList.add("is-busy");
    fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: item.getAttribute("data-key"), quantity: Math.max(0, qty), sections: SECTION, sections_url: location.pathname }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.sections) apply(data.sections[SECTION]);
        else refresh();
      })
      .catch(function () { refresh(); });
  }

  // ── Timer ────────────────────────────────────────────────────────────────
  // Loopt per bezoek (sessionStorage) en begint opnieuw als hij op nul staat, net als in UpCart.
  function timerEnd() {
    var r = root();
    var min = r ? parseInt(r.getAttribute("data-timer-minutes") || "10", 10) : 10;
    var end = 0;
    try { end = parseInt(sessionStorage.getItem(K_TIMER) || "0", 10); } catch (e) {}
    if (!(end > Date.now())) {
      end = Date.now() + min * 60 * 1000;
      try { sessionStorage.setItem(K_TIMER, String(end)); } catch (e) {}
    }
    return end;
  }

  function drawTimer() {
    var els = document.querySelectorAll("[data-cart-lade-timer]");
    if (!els.length) return;
    var left = Math.max(0, Math.round((timerEnd() - Date.now()) / 1000));
    var txt = Math.floor(left / 60) + ":" + ("0" + (left % 60)).slice(-2);
    els.forEach(function (el) { el.textContent = txt; });
  }

  function startTimer() {
    drawTimer();
    if (timerTick) return;
    timerTick = setInterval(function () {
      var r = root();
      if (!r || !r.classList.contains("is-open")) { clearInterval(timerTick); timerTick = null; return; }
      drawTimer();
    }, 1000);
  }

  // ── Haken in de pagina ───────────────────────────────────────────────────
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var r = root();

    if (r && r.contains(t)) {
      if (t.closest("[data-cart-lade-close]")) {
        var a = t.closest("a[href]");
        if (!a) e.preventDefault();
        close();
        return;
      }
      var q = t.closest("[data-cart-lade-qty]");
      if (q) {
        e.preventDefault();
        change(q.closest(".cart-lade__item"), parseInt(q.getAttribute("data-cart-lade-qty"), 10));
      }
      return;
    }

    if (onCartPage || !enabled()) return;
    var link = t.closest(".js-drawer-open-cart, a[href='/cart'], a[href$='/cart']");
    if (link) {
      e.preventDefault();
      e.stopImmediatePropagation();
      refresh();
      open();
    }
  }, true);

  // ── Checkout via Lasso ───────────────────────────────────────────────────
  var LASSO = !!document.querySelector('script[src*="lasso-script"]');
  var LASSO_WACHT_MS = 10000;
  function lassoKlaar() { return typeof window.proceedToCheckout === "function"; }

  function naarCheckout(btn, e) {
    // Lasso heeft de knop al omgebouwd en is klaar: hij handelt het zelf af.
    if (lassoKlaar() && btn.getAttribute("data-lasso-patched") === "true") return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (lassoKlaar()) { window.proceedToCheckout(); return; }
    btn.classList.add("is-wachten");
    var t0 = Date.now();
    (function wacht() {
      if (lassoKlaar()) { btn.classList.remove("is-wachten"); window.proceedToCheckout(); return; }
      if (Date.now() - t0 > LASSO_WACHT_MS) { btn.classList.remove("is-wachten"); location.href = "/checkout"; return; }
      setTimeout(wacht, 100);
    })();
  }

  if (LASSO) {
    document.addEventListener("click", function (e) {
      var btn = e.target && e.target.closest && e.target.closest("#CartLade .cart-lade__checkout");
      if (btn) naarCheckout(btn, e);
    }, true);
  }

  // Enter in het aantalveld mag het formulier niet versturen (dat zou naar /cart gaan, of
  // met Lasso zelfs naar de checkout); het telt als een wijziging van het aantal.
  document.addEventListener("keydown", function (e) {
    var t = e.target;
    if (e.key !== "Enter" || !t || !t.matches || !t.matches("[data-cart-lade-qty-input]")) return;
    e.preventDefault();
    t.blur();
  });

  document.addEventListener("change", function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches("[data-cart-lade-qty-input]")) return;
    var n = parseInt(t.value, 10);
    change(t.closest(".cart-lade__item"), isNaN(n) ? 0 : n);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { var r = root(); if (r && r.classList.contains("is-open")) close(); }
  });

  // Het thema heeft zijn eigen lade (#CartDrawer uit snippets/cart-drawer.liquid, gerenderd
  // in de header) en opent die op dezelfde events. Wij luisteren in de capture-fase op
  // window; die komt vóór de luisteraar van theme.js op document, dus met
  // stopImmediatePropagation ziet het thema het event niet en blijft zijn lade dicht.
  // Staat onze lade uit in de theme editor, dan gaat alles door naar die van het thema.
  function claim(handler) {
    return function (e) {
      if (onCartPage || !enabled()) return;
      e.stopImmediatePropagation();
      handler();
    };
  }
  window.addEventListener("ajaxProduct:added", claim(refreshAndOpen), true);
  window.addEventListener("cart:open", claim(function () { refresh(); open(); }), true);
  window.addEventListener("cart:close", claim(close), true);

  // Andere toevoegingen (apps, snelle weergave) gaan via fetch naar /cart/add.
  try {
    var origFetch = window.fetch;
    if (origFetch && !origFetch.__cartLade) {
      var patched = function (input, init) {
        var p = origFetch.apply(this, arguments);
        try {
          var url = typeof input === "string" ? input : (input && input.url) || "";
          if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
            p.then(function (res) { if (res && res.ok) refreshAndOpen(); }).catch(function () {});
          }
        } catch (e) {}
        return p;
      };
      patched.__cartLade = true;
      window.fetch = patched;
    }
  } catch (e) {}

  // Theme editor: de lade opent als je de sectie Winkelwagen aanklikt.
  document.addEventListener("shopify:section:select", function (e) { if (e.detail && e.detail.sectionId === SECTION) open(); });
  document.addEventListener("shopify:section:deselect", function (e) { if (e.detail && e.detail.sectionId === SECTION) close(); });
  document.addEventListener("shopify:section:load", function (e) {
    if (e.detail && e.detail.sectionId === SECTION) { updateBubble(); if (window.Shopify && Shopify.designMode) open(); }
  });

  updateBubble();
})();
